import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'i18n/utils'

/**
 * Hook that warns users about unsaved changes when they try to navigate away.
 * Works for both browser navigation (refresh/close tab) and SPA internal navigation.
 */
export default function useUnsavedChangesWarning(hasUnsavedChanges) {
    const history = useHistory()
    const t = useTranslation()

    const handleBeforeUnload = e => {
        e.preventDefault()
        e.returnValue = t('warning.unsaved.changes')
        return t('warning.unsaved.changes')
    }

    useEffect(() => {
        if (!hasUnsavedChanges) return

        window.addEventListener('beforeunload', handleBeforeUnload)

        const unblock = history.block(() => {
            const shouldContinue = window.confirm(t('warning.unsaved.changes'))
            return shouldContinue
        })

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload)
            unblock()
        }
    }, [hasUnsavedChanges, history, t])
}
